import { NodeControlPluginKey } from './NodeControlPlugin.js';

class NodeControlMeta {
  constructor(nodePos, nodeStart, currentNodeElement) {
    this.nodePos = nodePos;
    this.nodeStart = nodeStart;
    this.currentNodeElement = currentNodeElement;
  }
  static addResetToTransaction(tr) {
    tr.setMeta(NodeControlPluginKey, new NodeControlMeta(null, null, null));
    return tr;
  }
  static dispatchReset(editorView) {
    const tr = this.addResetToTransaction(editorView.state.tr);
    editorView.dispatch(tr);
  }
  static dispatchUpdate(editorView, nodePos, nodeStart, currentNodeElement) {
    const tr = editorView.state.tr.setMeta(NodeControlPluginKey, new NodeControlMeta(nodePos, nodeStart, currentNodeElement));
    editorView.dispatch(tr);
  }
  static isNodeControlMeta(meta) {
    return meta instanceof NodeControlMeta;
  }
}

export { NodeControlMeta };
//# sourceMappingURL=NodeControlMeta.js.map
